/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { useHeader } from '../context/HeaderContext';
import axios from 'axios';
import p1 from '../assets/profile/pro1.png';
import personalIcon from '../assets/profile/Vector (2).png';
import ProfessionalIcon from '../assets/profile/Vector (3).png';
import Account from '../assets/profile/Account.png';
import deactivate from '../assets/profile/deactivate.png';
import PasswordIcon from '../assets/profile/Vector (4).png';
import SocialIcon from '../assets/profile/Vector (6).png';
import coachingIcon from '../assets/profile/Vector (5).png';
import star from '../assets/profile/sstr.png';
import link from '../assets/profile/solar_link-linear.png';
import linkIcon from '../assets/profile/link.png';
import HeroSection from '../components/profile/HeroSection';
import DetailsSection from '../components/profile/DetailsSection';
import DetailsSection2 from '../components/profile/profilecont';
import ProfessionalDetails from '../components/profile/ProfessionalDetails';
import EditProfileActions from '../components/profile/EditProfileActions';
import ProfileProgress from '../components/profile/ProfileProgress';
import fallbackProfile from '../assets/profile/fallback.png';
import LogoutConfirmModal from '../components/controlVariations/LogoutConfirmModal';
import iconlogout from '../assets/images/icon/iconlogout.png';
import sign from '../assets/profile/sign.png';
import { useUserProfile } from '../hooks/useUserProfile';
import DetailsSection3 from '../components/profile/socialCont';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import SuccessContent from '../components/controlVariations/ModularSuccessModal';
import { useCountries } from '../hooks/useCountries';
import { useTimezones } from '../hooks/useTimezones';
import { usePreference } from '../hooks/usePreference';
import styles from '../styles/pages/ProfilePage.module.css';
import { useCoachPerformance } from '../hooks/useCoachPerformance';
import iconlogout2 from '../assets/icons/deleteimg.png';
import { useLearnerDashboardCounts } from '../hooks/useLearnerDashboardCounts';

import {
	validateEmail,
	validateFullNameUI,
	validatePassword,
	syncPasswordMatchError,
	validateLocation,
} from '../utils/validation'; // adjust path
import { validatePhoneNumber } from '../utils/validationSchema';
import CoachProgramsSection from '../components/profile/CoachProgramsSection';
import LearnerEnrollmentsSection from '../components/profile/LearnerEnrollmentsSection';
import { useLearnerAchievements } from '../hooks/useLearnerAchievements';
import DeleteAccountModal from '../components/pageComponents/managerUsers/DeleteAccountModal';
import { useAdminDashboardAnalytics } from '../hooks/useAdminDashboardAnalytics';
import { useDashboard } from '../hooks/useDashboard';
import { useUpcomingSessions } from '../hooks/useUpcomingSessions';
import { useLearnerProfilePrograms } from '../hooks/useCourse';

interface FormDataType {
	fullname: string;
	email: string;
	phonenumber: string;
	location: string;
	country: string;
	timezone: string;
	bio: string;

	metadata: {
		linkedin: string;
		twitter: string;
	};

	organizationname: string;
	designation: string;
	skills: string;
	areasofinterest: string[];
	website: string;
	yearsofexperience: number;
	languages: string;
}

const ProfilePage: React.FC = () => {
	const [isEditing, setIsEditing] = useState(false);
	const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
	const { setHeaderContent } = useHeader();
	// const [profileImage, setProfileImage] = useState(''); // default image
	const [profileImage, setProfileImage] = useState(fallbackProfile);
	const fileInputRef = useRef<HTMLInputElement>(null); // to trigger file input
	const { changePassword, logout } = useAuth();
	const navigate = useNavigate();
	const [pwLoading, setPwLoading] = useState(false);
	const [pwError, setPwError] = useState<string | null>(null);
	const [pwSuccess, setPwSuccess] = useState<string | null>(null);
	const [selectedImageFile, setSelectedImageFile] = useState<File | null>(
		null
	);
	const [showProfileSuccessPopup, setShowProfileSuccessPopup] =
		useState(false);
	// const [originalProfileImage, setOriginalProfileImage] = useState('');
	const [originalProfileImage, setOriginalProfileImage] =
		useState(fallbackProfile);
	const { countries, loading: countriesLoading } = useCountries();
	const { timezones, loading: timezonesLoading } = useTimezones();
	// FRONTEND ONLY PASSWORD FIELDS — NO BACKEND
	const [oldPassword, setOldPassword] = useState('');
	const [newPassword, setNewPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [showPasswordSuccessPopup, setShowPasswordSuccessPopup] =
		useState(false);
	const { updatePreferences } = usePreference();
	const { dashboardData } = useDashboard();
	

	const { deleteUser, deleteLoading } = useUserProfile();
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	// const [checked, setChecked] = useState(false);
	const [checked, setChecked] = useState<'indeterminate' | boolean>(false);
	const {
		analytics,
		loading: adminLoading,
		error: adminError,
		fetchAnalytics,
	} = useAdminDashboardAnalytics();

	// const [fieldErrors, setFieldErrors] = useState<Record<string, string | null>>({});
	const [formErrors, setFormErrors] = useState<Record<string, string>>({});
	const [fieldErrors, setFieldErrors] = useState<{
		oldPassword?: string;
		newPassword?: string;
		confirmPassword?: string;
	}>({});
	const {
		profile,
		loading,
		error,
		success,
		updateProfile,
		uploadProfilePicture,
		downloadFile,
		setProfile,
	} = useUserProfile();

	const {
		performance,
		loading: performanceLoading,
		error: performanceError,
		fetchCoachPerformance,
	} = useCoachPerformance();

	const {
		achievements,
		loading: achievementsLoading,
		error: achievementsError,
		fetchAchievements,
	} = useLearnerAchievements();

	

	const {
	sessions,
	
	refreshUpcomingSessions,
} = useUpcomingSessions(50);

const {
	dashboardCounts,
	loading: dashboardCountsLoading,
	error: dashboardCountsError,
} = useLearnerDashboardCounts();


const upcomingSessionsCount = Number(sessions?.[0]?.total || 0);


	const [formData, setFormData] = useState<FormDataType>({
		fullname: '',
		email: '',
		phonenumber: '',
		location: '',
		country: '',
		timezone: '',
		bio: '',

		metadata: {
			linkedin: '',
			twitter: '',
		},

		organizationname: '',
		designation: '',
		skills: '',
		yearsofexperience: 0,
		languages: '',
		website: '',
		areasofinterest: [],
	});
	const countryOptions = countries.map(c => c.label);
	const timezoneOptions = timezones.map(tz => tz.label);

	const handlePasswordFieldChange = (index: number, value: string) => {
		// if (index === 0) setOldPassword(value);

		if (index === 0) {
			setOldPassword(value);

			setFieldErrors(prev => ({
				...prev,
				oldPassword: value ? '' : 'Old password is required',
			}));
		}

		
		if (index === 1) {
			setNewPassword(value);

			const error = validatePassword(value);

			setFieldErrors(prev => ({
				...prev,
				newPassword: error || '',
			}));
		}

		
		if (index === 2) {
			setConfirmPassword(value);

			const error = syncPasswordMatchError(newPassword, value);

			setFieldErrors(prev => ({
				...prev,
				confirmPassword: error || '',
			}));
		}
	};

	const handlePasswordSave = async () => {
		
		let errors: any = {};

		if (!oldPassword) {
			errors.oldPassword = 'Old password is required';
		}

		if (!newPassword) {
			errors.newPassword = 'New password is required';
		}

		if (!confirmPassword) {
			errors.confirmPassword = 'Confirm password is required';
		}

		if (newPassword && confirmPassword && newPassword !== confirmPassword) {
			errors.confirmPassword = 'Passwords do not match';
		}

		if (oldPassword && newPassword && oldPassword === newPassword) {
			errors.newPassword = 'New password must be different';
		}

		if (newPassword && newPassword.length < 8) {
			errors.newPassword = 'Minimum 8 characters required';
		}

		setFieldErrors(errors);

		if (Object.keys(errors).length > 0) return;

		try {
			setPwLoading(true);

			// call the hook which calls authService.changePassword(...)
			const res = await changePassword(oldPassword, newPassword);

			if (res?.success) {
				setPwSuccess(res.message || 'Password changed successfully.');

				setOldPassword('');
				setNewPassword('');
				setConfirmPassword('');

				// show popup
				setShowPasswordSuccessPopup(true);

				// auto close after 3 seconds
				setTimeout(() => {
					setShowPasswordSuccessPopup(false);
				}, 3000);
			}
			
			else {
				const message = res?.message || 'Password change failed.';

				setFieldErrors(prev => ({
					...prev,
					oldPassword: message,
				}));

				setPwError(message);
			}
		} catch (err: any) {
			
			const message = err.message || 'Password change failed. Try again.';

			setFieldErrors(prev => ({
				...prev,
				oldPassword: message,
			}));

			setPwError(message);
		} finally {
			setPwLoading(false);
		}
	};

	useEffect(() => {
		const loadProfileImage = async () => {
			const base64Pic = await downloadFile(
				`/api/user/profile/download?type=profilepicture`
			);

			
			if (base64Pic) {
				setProfileImage(base64Pic);
				setOriginalProfileImage(base64Pic);
			} else {
				setProfileImage(fallbackProfile);
				setOriginalProfileImage(fallbackProfile);
			}
		};

		loadProfileImage();
	}, []);

	
	const handleCancel = async () => {
		setIsEditing(false);
		setSelectedImageFile(null);

		setFormErrors({});
		setFieldErrors({});
		setPwError(null);

		const base64Pic = await downloadFile(
			`/api/user/profile/download?type=profilepicture`
		);

		if (base64Pic) {
			setProfileImage(base64Pic);
			setOriginalProfileImage(base64Pic);
		} else {
			setProfileImage(fallbackProfile);
			setOriginalProfileImage(fallbackProfile);
		}
	};

	useEffect(() => {
		if (isEditing && profile) {
			console.log('🟢 Reassigning formData from profile:', profile);

			setFormData({
				fullname: profile.fullname ?? '',
				email: profile.email ?? '',
				phonenumber: profile.phonenumber ?? '',
				location: profile.location ?? '',
				country: profile.country ?? '',
				// timezone: profile.timezone ?? '',
				timezone: profile.preferences?.timezone ?? '',
				bio: profile.bio ?? '',

				
				languages: Array.isArray(profile.languages)
					? profile.languages[0] || ''
					: '',
				website: profile.website ?? '',
				metadata: {
					linkedin: profile.metadata?.linkedin ?? '',
					twitter: profile.metadata?.twitter ?? '',
				},

				skills: Array.isArray(profile.skills)
					? profile.skills.join(', ')
					: '',

				organizationname: profile.organizationname ?? '',
				designation: profile.designation ?? '',

				yearsofexperience: profile.yearsofexperience ?? 0,
				areasofinterest: Array.isArray(profile.areasofinterest)
					? profile.areasofinterest
					: [],
			});
		}

		console.log('🔍 formdata:', formData);
	}, [isEditing, profile]);

	const handleEdit = () => {
		//  setIsEditing(true);
		if (!profile) {
			console.warn('⚠️ Tried to edit before profile loaded!');
			return;
		}
		setFormErrors({});
		setFieldErrors({});
		setPwError(null);
		setIsEditing(true);
	};

	const handleChange = (field: string, value: string) => {
		// 🔹 Update form data first
		setFormData(prev => ({
			...prev,
			[field]:
				field === 'areasofinterest'
					? value
							.split(',')
							.map(x => x.trim())
							.filter(Boolean)
					: value,
		}));

		// 🔹 Inline validation
		let error: string | null = null;

		if (field === 'fullname') {
			error = validateFullNameUI(value);
		}

		if (field === 'email') {
			error = validateEmail(value);
		}
		// ✅ ADD THIS
		if (field === 'phonenumber') {
			// error = validatePhoneNumber(value);
			if (!value || value.trim() === '') {
				error = 'Phone number is required';
			} else {
				error = validatePhoneNumber(value);
			}
		}
		

		if (field === 'location') {
			// error = validateLocation(value);
			if (!value || value.trim() === '') {
				error = 'Location is required';
			} else {
				error = validateLocation(value);
			}
		}

		if (field === 'organizationname') {
    if (!value || value.trim() === '') {
        error = 'Organization Name is required';
    }
}

		if (field === 'website') {
			if (!value || value.trim() === '') {
				error = 'Website is required';
			} else {
				error = validateURL(value);
			}
		}

		if (field === 'linkedin') {
			if (!value || value.trim() === '') {
				error = 'LinkedIn profile is required';
			} else {
				error = validateURL(value);
			}
		}

		if (field === 'twitter') {
			if (!value || value.trim() === '') {
				error = 'Twitter profile is required';
			} else {
				error = validateURL(value);
			}
		}

		setFormErrors(prev => ({
			...prev,
			[field]: error || '',
		}));
	};
	const [shouldSave, setShouldSave] = useState(false);

	useEffect(() => {
		if (shouldSave) {
			const hasErrors = Object.values(formErrors).some(
				err => err && err.trim() !== ''
			);

			if (hasErrors) {
				console.warn('❌ Prevented API call due to errors');
				setShouldSave(false);
				return;
			}
			const saveAll = async () => {
				try {
					if (selectedImageFile) {
						console.log('📸 Uploading selected image...');

						await uploadProfilePicture(
							selectedImageFile,
							'profilepicture'
						);

						const base64Pic = await downloadFile(
							`/api/user/profile/download?type=profilepicture`
						);
						// if (base64Pic) setProfileImage(base64Pic);
						if (base64Pic) {
							setProfileImage(base64Pic);
							setOriginalProfileImage(base64Pic); // ✅ update original too
						}
					}

					const payload: any = {
						fullname: formData.fullname?.trim(),
						phonenumber: formData.phonenumber?.trim(),
						location: formData.location?.trim(),
						country: formData.country?.trim(),
						//   timezone: formData.timezone?.trim(),
						bio: formData.bio?.trim(),
						website: formData.website?.trim(),
						metadata: {
							linkedin: formData.metadata?.linkedin?.trim(),
							twitter: formData.metadata?.twitter?.trim(),
						},

						organizationname: formData.organizationname,
						designation: formData.designation,
						//   skills: formData.skills,
						skills: formData.skills
							? formData.skills
									.split(',')
									.map(x => x.trim())
									.filter(Boolean)
							: [],
						yearsofexperience: String(formData.yearsofexperience),
						areasofinterest: formData.areasofinterest,
						//   languages: formData.languages,
						languages: formData.languages
							? [formData.languages]
							: [],
					};

					// remove empty fields
					Object.keys(payload).forEach(key => {
						if (payload[key] === '' || payload[key] === null) {
							delete payload[key];
						}
					});

					console.log('📤 Sending payload:', payload);

					// 3️⃣ Update profile text fields
					await updateProfile(payload);
					// setIsEditing(false);
					setProfile((prev: any) => ({
						...prev,
						...payload,
						metadata: {
							...prev?.metadata,
							...payload.metadata,
						},
					}));
					// 4️⃣ Update timezone separately (IMPORTANT)
					if (formData.timezone) {
						await updatePreferences({
							timezone: formData.timezone,
						});

						setProfile((prev: any) => ({
							...prev,
							preferences: {
								...prev?.preferences,
								timezone: formData.timezone,
							},
						}));
					}

					setShowProfileSuccessPopup(true);

					setTimeout(() => {
						setShowProfileSuccessPopup(false);
					}, 3000);

					// 4️⃣ Clean up
					setSelectedImageFile(null);
					setIsEditing(false);
					setShouldSave(false);
				} catch (err) {
					console.error('❌ Error saving profile:', err);
					setShouldSave(false);
				}
			};

			saveAll();
		}
	}, [shouldSave]);

	const handleSave = () => {
		const hasErrors = Object.values(formErrors).some(
			err => err && err.trim() !== ''
		);

		if (hasErrors) {
			console.warn('❌ Fix validation errors before saving');
			return;
		}
		setShouldSave(true);
	};

	const handleImageUploadClick = () => {
		fileInputRef.current?.click(); // 👈 opens hidden file input
	};

	const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (!e.target.files || e.target.files.length === 0) return;

		const file = e.target.files[0];
		setSelectedImageFile(file); // store file for upload on Save

		// 👉 Show temporary preview without uploading
		const previewUrl = URL.createObjectURL(file);
		setProfileImage(previewUrl);

		console.log('Image selected → preview shown, not uploaded');
	};

	const validateURL = (value: string): string => {
		if (!value) return '';

		try {
			const url = new URL(value);

			// only allow http/https
			if (!['http:', 'https:'].includes(url.protocol)) {
				return 'URL must start with http or https';
			}

			return '';
		} catch {
			return 'Enter a valid URL';
		}
	};

	
	const handleSocialChange = (platform: string, value: string | null) => {
		const val = value ?? '';

		let error = '';

		if (platform === 'linkedin') {
			if (!val.trim()) {
				error = 'LinkedIn profile is required';
			} else {
				error = validateURL(val);
			}
		}

		if (platform === 'twitter') {
			if (!val.trim()) {
				error = 'Twitter profile is required';
			} else {
				error = validateURL(val);
			}
		}

		if (platform === 'website') {
			if (!val.trim()) {
				error = 'Website is required';
			} else {
				error = validateURL(val);
			}
		}

		setFormData(prev => ({
			...prev,
			metadata: {
				...prev.metadata,
				[platform]: val,
			},
			website: platform === 'website' ? val : prev.website,
		}));

		setFormErrors(prev => ({
			...prev,
			[platform]: error,
		}));
	};

	const handleFieldChange = (
		field: string,
		value: string,
		parent?: 'metadata'
	) => {
		setFormData(prev => {
			// metadata fields
			if (parent === 'metadata') {
				return {
					...prev,
					metadata: {
						...prev.metadata,
						[field]: value,
					},
				};
			}

			// normal fields
			return {
				...prev,
				[field]: value,
			};
		});
	};
	const calculateProfileCompletion = () => {
		if (!profile) return 0;

		let personalScore = 0;
		let professionalScore = 0;
		let socialScore = 0;

		const personalFields = [
			profile.fullname,
			profile.phonenumber,
			profile.location,
			profile.website,
			profile.languages?.length ? 'ok' : '',
		];

		const personalFilled = personalFields.filter(
			x => x && x.trim() !== ''
		).length;
		personalScore = (personalFilled / personalFields.length) * 40;

		const professionalFields = [
			profile.organizationname,
			profile.designation,
			profile.skills?.length ? 'ok' : '',
			profile.areasofinterest?.length ? 'ok' : '',
		];

		const professionalFilled = professionalFields.filter(
			x => x && x.trim() !== ''
		).length;
		professionalScore =
			(professionalFilled / professionalFields.length) * 40;

		const socialFields = [
			profile.metadata?.linkedin,
			profile.metadata?.instagram,
			profile.metadata?.facebook,
		];

		const socialFilled = socialFields.filter(
			x => x && x.trim() !== ''
		).length;
		socialScore = (socialFilled / socialFields.length) * 20;

		// FINAL PERCENTAGE
		return Math.round(personalScore + professionalScore + socialScore);
	};

	const [completion, setCompletion] = useState(0);

	useEffect(() => {
		if (profile) {
			const percent = calculateProfileCompletion();
			console.log('📊 Calculated Profile Completion:', percent);
			setCompletion(percent);
		}
	}, [profile]);

	useEffect(() => {
		if (!profile) return; // ✅ Wait until profile loads

		setHeaderContent(
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					width: '100%',
				}}
			>
				<h2 style={{ fontSize: '20px', fontWeight: '600', margin: 0 }}>
					My Profile
				</h2>

				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: '16px',
					}}
				>
					

					<EditProfileActions
						onEditClick={handleEdit}
						onUndoClick={handleCancel}
						onSaveClick={handleSave}
						onCancelClick={handleCancel}
						isEditing={isEditing}
					/>
				</div>
			</div>
		);

		return () => {
			setHeaderContent(null); // cleanup on unmount
		};
	}, [profile, completion]);

	// 🔹 Show success feedback (optional)
	if (success) console.log('✅ Profile updated successfully!');

	
	const role: 'coach' | 'coachee' | 'admin' =
		profile?.rolename === 'superadmin'
			? 'admin'
			: profile?.rolename === 'coach'
				? 'coach'
				: 'coachee';

				

	useEffect(() => {

		
		if (role === 'coach' && profile?.id) {
			fetchCoachPerformance(profile.id);
		}
		if (role === 'coachee' && profile?.id) {
			fetchAchievements(profile.id);
		}

		if (role === 'admin') {
			fetchAnalytics();

		}
	}, [role, profile?.id]);

		const {
    programs: learnerPrograms,
    isLoading: learnerProgramsLoading,
    error: learnerProgramsError,
} = useLearnerProfilePrograms(
    role === 'coachee' && profile?.id ? profile.id : ''
);

	// ✅ THEN returns
	if (loading) return <p>Loading profile...</p>;
	// if (error) return <p style={{ color: 'red' }}>{error}</p>;
	if (!profile) return <p>No profile data found.</p>;

	const roleData = analytics?.roledistribution;
	const totalUsers = analytics?.totalusers;
	const completionRates = analytics?.completionrates;

	const activePrograms = analytics?.learnersassignmentcompletion?.length ?? 0;

	const handleLogout = async () => {
		try {
			await logout();
			navigate('/login', { replace: true });
		} catch (error) {
			console.error('Logout failed');
			navigate('/login', { replace: true });
		}
	};

	

	const handleConfirmDelete = async () => {
		try {
			if (!profile?.id) return;

			const success = await deleteUser(profile.id);
			console.log(success);

			if (success) {
				await logout();
				navigate('/login', { replace: true });
			}
		} catch (err) {
			console.error('Delete failed:', err);
		}
	};
	
	
	return (
		<>
			<div className={styles.container}>
				<h2 className={styles.title}>My Profile</h2>

				<div className={styles.actions}>
					<EditProfileActions
						onEditClick={handleEdit}
						onUndoClick={handleCancel}
						onSaveClick={handleSave}
						onCancelClick={handleCancel}
						isEditing={isEditing}
					/>
				</div>
			</div>

			<HeroSection
				isEditing={isEditing}
				profileImage={profileImage}
				fullName={profile.fullname}
				// role={profile.rolename ?? "coachee"}
				role={role}
				bio={isEditing ? formData.bio : (profile.bio ?? '')}
				// ✅ REAL DATA
				badges={achievements?.badges || 0}
				certificates={achievements?.certificates || 0}
				courses={
	role === 'coachee' ? learnerPrograms?.length || 0 : undefined
}
				totalSessions={dashboardCounts?.summary?.activities.total || 0}
				onBioChange={value => handleChange('bio', value)}
				onImageUploadClick={handleImageUploadClick}
				learnersCoached={performance?.learnerscoached}
				coachingHours={performance?.coachinghours}
				avgRating={performance?.avgrating}
				programsDelivered={performance?.programsdelivered}
				activeCoaches={roleData?.coaches ?? 0}
				activeLearners={roleData?.learners ?? 0}
				upcomingSessions={upcomingSessionsCount}
				activePrograms={activePrograms}
			/>

			{/* Hidden file input for uploading images */}
			<input
				type="file"
				accept="image/*"
				ref={fileInputRef}
				style={{ display: 'none' }}
				onChange={handleFileChange}
			/>

			<div className={styles.detailsWrapper}>
				<DetailsSection
					sectionTitle="Personal Details"
					iconSrc={personalIcon}
					fields={[
						{
							label: 'Full Name',
							value: isEditing
								? formData.fullname
								: profile.fullname || '',
							key: 'fullname',
							//  error: fieldErrors.fullname
							error: formErrors.fullname,
						},
						{
							label: 'Email',
							value: isEditing
								? formData.email
								: profile.email || '',
							key: 'email',
						},
						{
							label: 'Phone Number',
							value: isEditing
								? formData.phonenumber
								: profile.phonenumber || '',
							key: 'phonenumber',
							error: formErrors.phonenumber,
						},
						{
							label: 'Location',
							value: isEditing
								? formData.location
								: profile.location || '',
							key: 'location',
							error: formErrors.location,
						},

						{
							label: 'Country Name',
							value: isEditing
								? formData.country
								: profile.country || '',
							key: 'country',
							isDropdown: true,

							options: countryOptions,
						},
						{
							label: 'Time Zone',
							// value: isEditing ? formData.timezone : profile.timezone || '',
							value: isEditing
								? formData.timezone
								: profile.preferences?.timezone || '',
							key: 'timezone',
							isDropdown: true,

							options: timezoneOptions,
						},
					]}
					isEditing={isEditing}
					onFieldChange={handleChange}
				/>

				<DetailsSection
					sectionTitle="Professional Details"
					iconSrc={ProfessionalIcon}
					fields={[
						{
							label: 'Organization Name',

							value:
								(isEditing
									? formData.organizationname
									: profile.organizationname) || '',
							key: 'organizationname',
							error: formErrors.organizationname,
						},
						{
							label: 'Current Professional Role',
							value:
								(isEditing
									? formData.designation
									: profile.designation) || '',
							key: 'designation',
							isDropdown: true,
							options: [
								'HR / L&D / OD',
								'Business Leader',
								'Independent Coach',
								'Entrepreneur',
								'Other',
							],
						},

						{
							label: 'Total years of work experience',
							value:
								(isEditing
									? String(formData.yearsofexperience)
									: String(
											profile.yearsofexperience ?? ''
										)) || '',
							key: 'yearsofexperience',
							isDropdown: true,
							options: [
								'0-5 years of experience',
								'5-10 years of experience',
								'10-15 years of experience',
								'15+ years of experience',
							],
						},
						{
							label: 'Areas of Interest',
							value:
								(isEditing
									? formData.areasofinterest.join(', ')
									: (profile.areasofinterest || []).join(
											', '
										)) || '',

							key: 'areasofinterest',
							isMultiSelect: true,
							options: [
								'ICF Coaching Credentials',
								'Mentoring',
								'Coaching culture',
								'Leadership Workshops',
								'Psychological Safety',
								'Emotional Agility',
								'1 on 1 Coaching',
								'Group Coaching',
								'Team Coaching',
								'Research Benchmarking',
								'Assessments',
							],
						},
					]}
					isEditing={isEditing}
					onFieldChange={handleChange}
				/>
			</div>
			<div className={styles.detailsWrapper}>
				{role === 'coach' && (
					<DetailsSection
						sectionTitle="Skills & Expertise"
						iconSrc={star} // or create new icon
						fields={[
							{
								label: 'Areas of Expertise',

								value: isEditing
									? formData.skills
									: (profile.skills || []).join(', '),
								key: 'skills',
								isChipInput: true,
								placeholder:
									'e.g. Leadership, Coaching, Communication',
							},
							//       {
							//         label: "Languages Spoken",
							//         // value: profile.languages?.join(", ") || "English",
							//         value: isEditing
							//   ? formData.languages
							//   : (profile.languages || []).join(", "),
							//         key: "languages",
							//       },
							{
								label: 'Languages Spoken',
								value: isEditing
									? formData.languages
									: profile.languages?.[0] || '',
								key: 'languages',
								isDropdown: true,
								options: ['English (Native)'],
							},
						]}
						isEditing={isEditing}
						onFieldChange={handleChange}
					/>
				)}
				{role === 'coach' && (
					<DetailsSection
						sectionTitle="Social & Web Links"
						iconSrc={link}
						fields={[
							{
								label: 'LinkedIn Profile',
								value: isEditing
									? formData.metadata.linkedin
									: profile.metadata?.linkedin || '',
								key: 'linkedin',
								error: formErrors.linkedin,
							},
							{
								label: 'Personal Website / Portfolio',
								value: isEditing
									? formData.website
									: profile.website || '',
								key: 'website',
								error: formErrors.website,
							},
							{
								label: 'Twitter / X Profile',
								value: isEditing
									? formData.metadata.twitter
									: profile.metadata?.twitter || '',
								key: 'twitter',
								error: formErrors.twitter,
							},
						]}
						isEditing={isEditing}
						// onFieldChange={handleChange}
						onFieldChange={handleSocialChange}
					/>
				)}
			</div>

			<DetailsSection2
				sectionTitle="Change Password"
				iconSrc={PasswordIcon}
				fields={[
					{
						label: 'Old Password',
						value: oldPassword,
						placeholder: '********',
						type: 'password',
						error: fieldErrors.oldPassword,
					},
					{
						label: 'Change Password',
						value: newPassword,
						placeholder: '********',
						type: 'password',
						error: fieldErrors.newPassword,
					},
					{
						label: 'Re-enter Password',
						value: confirmPassword,
						placeholder: '********',
						type: 'password',
						error: fieldErrors.confirmPassword,
					},
				]}
				isEditing={true}
				showSave={true}
				onFieldChange={handlePasswordFieldChange}
				onSaveClick={handlePasswordSave}
			/>

			{role === 'coach' && profile?.id && (
				<CoachProgramsSection coachId={profile.id} />
			)}

			{role === 'coachee' && profile?.id && (
				<LearnerEnrollmentsSection learnerId={profile.id} />
			)}

			<div className={styles.header}>
				<div className={styles.head}>
					<div className={styles.iconCont}>
						{' '}
						<img
							src={Account}
							alt="ACCOUNT MANAGMENT"
							className={styles.icon}
						/>
					</div>
					<h3 className={styles.title}>account Management</h3>
				</div>

				{role === 'coachee' && isEditing ? (
					<>
						<button
							className={styles.editLogout} // new style
							onClick={() => setOpenDeleteModal(true)}
						>
							<img src={deactivate} alt="logout" />
							Deactivate Account
						</button>
						<span className={styles.signcont}>
							{' '}
							<img
								className={styles.sign}
								src={sign}
								alt="logout"
							/>
							Deactivating account is irreversible action. You
							will lose all enrollments and achievements.
						</span>
					</>
				) : (
					<button
						className={styles.logout}
						onClick={() => setShowLogoutConfirm(true)}
					>
						<img
							src={iconlogout}
							alt="logout"
							style={{ width: '18px' }}
						/>
						Logout
					</button>
				)}
			</div>

			<DeleteAccountModal
				open={openDeleteModal}
				icon={iconlogout2}
				title="Are you sure you want to delete account?"
				confirmText="Delete"
				cancelText="Cancel"
				onConfirm={handleConfirmDelete}
				onCancel={() => setOpenDeleteModal(false)}
				showCheckbox={false} 
				checkboxChecked={checked}
				onCheckboxChange={setChecked}
				disableConfirm={deleteLoading}
			/>

			{showLogoutConfirm && (
				<LogoutConfirmModal
					open={showLogoutConfirm}
					onConfirm={handleLogout}
					onCancel={() => setShowLogoutConfirm(false)}
				/>
			)}

			{showPasswordSuccessPopup && (
				<SuccessContent
					title="Password Changed Successfully"
					subtitle="Your password has been updated."
				/>
			)}
			{showProfileSuccessPopup && (
				<SuccessContent
					title="Profile Updated Successfully"
					subtitle="Your profile information has been saved."
				/>
			)}
		</>
	);
};

export default ProfilePage;
